import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2f50122"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "10",
  height: "8",
  viewBox: "0 0 10 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.04853 0.337612C9.41423 0.585541 9.50971 1.08299 9.26178 1.4487L5.19413 7.4487C5.06129 7.64465 4.84849 7.7717 4.61298 7.79567C4.37747 7.81965 4.14343 7.73808 3.97383 7.57293L0.841479 4.5226C0.524942 4.21436 0.518222 3.70787 0.82647 3.39133C1.13472 3.0748 1.6412 3.06808 1.95774 3.37632L4.40578 5.76025L7.93744 0.550871C8.18536 0.185162 8.68282 0.0896829 9.04853 0.337612Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dw-checkbox", {
            'dw-checkbox--checked': _ctx.checked,
            'dw-checkbox--disabled': _ctx.disabled
        }])
  }, _hoisted_2, 2))
}